// extracted by mini-css-extract-plugin
export default {"container":"Privacy_container__JelB5","content":"Privacy_content__o9sCn","title":"Privacy_title__h7ACk","date":"Privacy_date__msnzM"};